import { render, staticRenderFns } from "./DetailBlast.vue?vue&type=template&id=696c3cd8&"
import script from "./DetailBlast.vue?vue&type=script&lang=js&"
export * from "./DetailBlast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports